











import ToggleSwitch from './ToggleSwitch.vue'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  components: {
    ToggleSwitch
  }
})
export default class MassAssetToggle extends Vue {
  @Prop() scrollPosition!:any

  checked:boolean = true
  show:boolean = false

  @Watch('scrollPosition', { immediate: true })
  onScrollPositionChange () {
    this.show = this.scrollPosition > 80
  }

  @Watch('checked')
  onCheckedChange () {
    if (this.checked) {
      this.$emit('massSelect', 'all')
    } else {
      this.$emit('massSelect', 'none')
    }
  }
}
